import React, {Component} from 'react';
import ClientPageBackButton from "../ClientPageBackButton";
import ScrollToComponent from "../ScrollToComponent";

import AmetekFour from '../../images/amatek-four.jpg';
import AmetekFive from '../../images/amatek-five.jpg';

var AmetekFiveImg = {
	backgroundPosition: "center center",
	backgroundSize: "cover",
	backgroundImage: `url(${AmetekFive})`,
	marginTop: '0'
};

var AmetekFourImg = {
	backgroundPosition: "center center",
	backgroundSize: "cover",
	backgroundImage: `url(${AmetekFour})`,
	marginTop: '0'
};

export default class AmetekPage extends Component {
	constructor(props) {
		super(props);
	}

	scrollNodes = [
		'#section2',
		'#section3',
		'#privredni_razvoj',
		'#medijska_podrska'
	];

	render() {
		return (
			<div className="smart-page">
				<ClientPageBackButton parentThis={this} currentSlideGroup={2} />
				<ScrollToComponent scrollNodes={this.scrollNodes}/>
                <img src="/img/Ametek-9-samo-baloni.jpg" alt="heading image" className="ametek-first-image"/>
                <section className="first-section-padding">
                    <div className="images-holder-ametek">
                        <img className="top" src="/img/amatek-left-first.jpg" alt=""/>
                        <img className="bottom" src="/img/amatek-index1.jpg" alt=""/>
                    </div>
                </section>
				<section id="section2" className="full-one red-amatek">
					<div className="cont-992 ">
						<div className="amatek-logo">
							<div className="am-logo"><img className="" src="/img/amatek-logo.png"/></div>
						</div>
						<div className="">
							<div className="amatek-left-top">
								<p className="amatek-title">NEW BUSINESS CAMPUS</p>
								<p className="amatek-first-text">n our event portfolio we also have the US company Ametek, the manufacturer of large range engines which opened a new business campus in Subotica in 2017.<br/>
								The factory was opened by the president of the state, in the presence of media and respectable guests.</p>
							</div>
						</div>
					</div>
				</section>

				<section id="section3" className="amatek-sec">
					<div className="amatek-first-abs"><img src="/img/amatek-first-abs.jpg"/></div>
				</section>


				<section id="section_4" className="amatek-third flex1">
					<div className="amatek-third-top">
						<img src="/img/amatek-third-back-one.jpg"/>
						<div className="left-60" id="privredni_razvoj">
							<p className="amatek-title text-float-left">WE FOLLOW ECONOMIC DEVELOPMENT</p>
							<p className="amatek-first-text white-text">Along with economic giants, we follow their economic development, and among them is the German company Dunkermotoren, for which we organized, at the time when it enlarged its production plants, a ceremony with which the company celebrated its development. Technical support and the organization of event, design of promotional material, coordination of guests, this was all only a part of the activities we carried out on the occasion.</p>
						</div>
					</div>
					<div className="amatek-third-right" id="amatek_third_back">
						<img src="/img/amatek-third-back-two.jpg"/>
					</div>
				</section>

				<div className="amatek-four" id="amatek_four" style={AmetekFourImg}>
				</div>

				<section id="section_6" className="amatek-five" style={AmetekFiveImg}>
					<div className="amatek-five-text" id="medijska_podrska">
						<div className="width-ametek-text">
							<p className="amatek-title text-float-left">MEDIA AND PR SUPPORT</p>
							<p className="amatek-first-text ">Beside creative and technical support for the opening of the Dunkermotoren factory, the Smart team was also in charge of this significant development project getting its well-deserved media attention.</p>
						</div>
					</div>
				</section>

				<section id="section_7" className="amatek-last"><img className="small-img" src="/img/amate-last-one.jpg"/>
				</section>

			</div>
		)
	}
}


// WEBPACK FOOTER //
// ./src/components/English/AmetekEnglishPage.js